import React from 'react';
import './Trust.css';

export default function Trust() {
  const trustItems = [
    {
      icon: '💸',
      title: 'Best price guarantee',
      description: "Find it cheaper and we'll match it — no questions asked.",
    },
    {
      icon: '🕑',
      title: '24×7 real support',
      description: 'Talk to a human any time, before and during your trip.',
    },
    {
      icon: '✅',
      title: 'Verified stays',
      description: 'Every property is checked so there are no nasty surprises.',
    },
  ];

  return (
    <section className="block">
      <div className="container">
        <div className="trust">
          {trustItems.map((item, idx) => (
            <div key={idx} className="item">
              <span className="ico">{item.icon}</span>
              <div>
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
